import CASL from '@/utils/constants/casl'

export default [
  {
    path: 'segmentation',
    name: 'library.segmentation',
    meta: {
      title: 'Segmentation',
      action: 'read',
      subject: CASL.ACCESS.SEGMENTATION
    },
    component: () => import('./list/SegmentationListPage.vue')
  },
  {
    path: 'segmentation/add',
    name: 'library.segmentation.add',
    meta: {
      title: 'Segmentation Add',
      action: 'create',
      subject: CASL.ACCESS.SEGMENTATION
    },
    component: () => import('./form/SegmentationFormPage.vue')
  }
]
